import { Component, inject, model } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatCalendarCellClassFunction } from '@angular/material/datepicker';

import { TranslatePipe } from '@ngx-translate/core';

import { DateSelectionComponent } from './date-selection/date-selection.component';
import { GreenhouseDataOverviewComponent } from './overview/data-overview.component';
import { RtudataStore } from './rtudata.store';
import { GreenhouseDataSwitcherComponent } from './switcher/data-switcher.component';

@Component({
  imports: [
    GreenhouseDataSwitcherComponent,
    GreenhouseDataOverviewComponent,
    DateSelectionComponent,
    TranslatePipe,
  ],
  providers: [provideNativeDateAdapter()],
  selector: 'norupe-greenhouse',
  styles: [``],
  template: `<header class="flex justify-between">
      <h3 class="max-w-7xl flex-wrap items-center gap-6 text-xl font-bold">
        {{ 'MONITORING.title' | translate }}
      </h3>

      <norupe-date-selection />
    </header>
    <div class="p-2">
      <norupe-greenhouse-data-overview />
      <norupe-greenhouse-data-switcher />
    </div>`,
})
export class RtudataComponent {
  readonly RtudataStore = inject(RtudataStore);
  selected = model<Date | null>(null);

  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    // Only highligh dates inside the month view.
    if (view === 'month') {
      const date = cellDate.getDate();

      // Highlight the 1st and 20th day of each month.
      return date === 1 || date === 20 ? 'custom-date-class' : '';
    }

    return '';
  };
}
